import React, { memo } from 'react';

const LoadingOverlay = memo(() => (
  <div className="fixed inset-0 bg-white/70 backdrop-blur-sm z-20 flex items-center justify-center">
    <div className="flex flex-col items-center gap-3">
      <div className="animate-spin rounded-full h-9 w-9 border-2 border-indigo-600 border-t-transparent" />
      <p className="text-xs text-gray-400 font-medium">Fetching analytics...</p>
    </div>
  </div>
));

export default LoadingOverlay;
